/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';

export class payer_index extends IceEntity {
  payer_index_key: string = "";
  trans_account: string = "";
  organization_name: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  identification_code1: string = "";
  identification_code2: string = "";
  identification_code3: string = "";
  identification_code4: string = "";
  identification_code5: string = "";
  identification_code6: string = "";
  identification_code_qualifier1: string = "";
  identification_code_qualifier2: string = "";
  identification_code_qualifier3: string = "";
  identification_code_qualifier4: string = "";
  identification_code_qualifier5: string = "";
  identification_code_qualifier6: string = "";

  additional_name: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "PAYER_INDEX";
  }

  getdisplayname(organization: boolean): string {
    return this.organization_name;
  }
}
